import { withThemeCreator } from '@material-ui/styles';
import defaultTheme from './defaultTheme';
var withTheme = withThemeCreator({
  defaultTheme: defaultTheme
});
export default withTheme;


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/styles/withTheme.js
// module id = 1651
// module chunks = 121